import { DataTable, FormDateRangePicker, Heading, Loader } from "@/components";
import usePaymentListing from "./useListing";
import { Button } from "@/components/ui";
import { FormProvider } from "react-hook-form";
import { SEARCH_CRITERIA } from "./consts";

const Listing = () => {
  const {
    breadcrumbData,
    columns,
    globalFilter,
    setGlobalFilter,
    onRowClick,
    isDocLoading,
    documentList,
    setPageNumber,
    setPageSize,
    pageNumber,
    pageSize,
    sorting,
    setSorting,
    isDocRefetching,
    form,
    onSubmit,
    requiredFields,
    onClear,
    communityDetail,
    isMobile,
    onAdd,
    currentFinanceYear
  } = usePaymentListing();
  const { errors } = form.formState;

  return (
    <div className="p-4 md:p-6">
      {/* Header & Search */}
      <div className="flex flex-col xl:flex-row gap-2 xl:items-center xl:justify-between mb-6">
        <div className="flex flex-row items-center justify-between">
          <Heading
            title={<span>Cash App - {communityDetail?.name} <span className="text-[12px]">(FY-{currentFinanceYear})</span></span>}
            breadcrumbData={breadcrumbData}
          />
          {isMobile && (
            <Button className="px-2" onClick={onAdd}>
              + Add Cash App
            </Button>
          )}
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 mt-[10px] gap-[10px]">
          <div className="col-span-2">
            <FormProvider {...form}>
              <form onSubmit={form.handleSubmit(onSubmit)}>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-[10px]">
                  <div className="col-span-2">
                    <FormDateRangePicker
                      name={SEARCH_CRITERIA}
                      control={form.control}
                      label="Date Range"
                      placeholder="Please select"
                      error={errors[SEARCH_CRITERIA]?.message}
                      isRequired={requiredFields.includes(SEARCH_CRITERIA)}
                    />
                    <div className="flex items-center justify-end">
                      <Button
                        variant="ghost"
                        type="button"
                        onClick={onClear}
                        className="text-[12px] p-0 m-0"
                      >
                        Clear
                      </Button>
                    </div>
                  </div>
                  <Button type="submit">Search</Button>
                </div>
              </form>
            </FormProvider>
          </div>
          {!isMobile && <Button onClick={onAdd}>+ Add Cash App</Button>}
        </div>
      </div>

      {/* Responsive Table */}
      {isDocLoading || isDocRefetching ? (
        <Loader />
      ) : (
        <>
          <DataTable
            columns={columns}
            data={documentList?.data || []}
            setGlobalFilter={setGlobalFilter}
            globalFilter={globalFilter}
            onRowClick={onRowClick}
            setPageNumber={setPageNumber}
            setPageSize={setPageSize}
            pageNumber={pageNumber}
            pageSize={pageSize}
            totalPages={Math.ceil(documentList?.total / pageSize)}
            totalRecords={documentList?.total}
            serverSidePagination={true}
            sorting={sorting}
            onSortingChange={setSorting}
          />
        </>
      )}
    </div>
  );
};

export default Listing;
